import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Box, IconButton } from '@mui/material';
import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid';
import { AdobeJobStatus } from '@prisma/client';
import { Dispatch, SetStateAction } from 'react';
import { SEPA_MANDATE_AGREEMENT_TABLE_TYPE } from 'src/utils/tableUtils';

export type SepaAgreementCallToActionsProps = {
    params: GridRenderCellParams<unknown, unknown, unknown, GridTreeNodeWithRender>;
    dataTestIdKey: string;
    handleViewRecord: (row: unknown) => void;
    setIsDeleteConfirmModalOpen: (value: SetStateAction<boolean>) => void;
    setIdToDelete: Dispatch<(prevState: undefined) => undefined>;
    setIsRemindConfirmModalOpen: (value: SetStateAction<boolean>) => void;
    setIdToRemind: Dispatch<(prevState: undefined) => undefined>;
    agreementType: SEPA_MANDATE_AGREEMENT_TABLE_TYPE;
};

export function SepaAgreementCallToActions({
    params,
    dataTestIdKey,
    setIsDeleteConfirmModalOpen,
    setIdToDelete,
    handleViewRecord,
    setIsRemindConfirmModalOpen,
    setIdToRemind,
    agreementType,
}: SepaAgreementCallToActionsProps) {
    return (
        <Box
            data-testid={`${dataTestIdKey}-dd-row-call-to-actions`}
            sx={{
                display: 'flex',
                height: '100%',
                justifyContent: 'flex-end',
                width: '100%',
            }}
        >
            {params?.row?.status !== AdobeJobStatus.SIGNED && (
                <IconButton
                    aria-label="remind"
                    hidden={params?.row?.status === AdobeJobStatus.SIGNED}
                    onClick={() => {
                        setIsRemindConfirmModalOpen(true);
                        setIdToRemind({
                            id:
                                typeof params?.row?.id === 'string'
                                    ? Number.parseInt(params?.row?.id)
                                    : params?.row?.id,
                            agreementType,
                        });
                    }}
                >
                    <ReplayOutlinedIcon />
                </IconButton>
            )}

            {params?.row?.status !== AdobeJobStatus.OUT_FOR_SIGNATURE && (
                <IconButton
                    data-testid={`view-${dataTestIdKey}-dd-agreement-pdf-button`}
                    aria-label="view"
                    hidden={params?.row?.status === AdobeJobStatus.OUT_FOR_SIGNATURE}
                    onClick={() => {
                        handleViewRecord(params?.row);
                    }}
                >
                    <VisibilityOutlinedIcon />
                </IconButton>
            )}

            <IconButton
                data-testid={`delete-${dataTestIdKey}-dd-agreement-pdf-button`}
                aria-label="delete"
                onClick={() => {
                    setIsDeleteConfirmModalOpen(true);
                    setIdToDelete(
                        typeof params?.row?.id === 'string'
                            ? Number.parseInt(params?.row?.id)
                            : params?.row?.id
                    );
                }}
            >
                <DeleteOutlineOutlinedIcon />
            </IconButton>
        </Box>
    );
}
